// extracted by mini-css-extract-plugin
export default {"ApplicationQuery":"ApplicationQuery_ApplicationQuery__-OK1Y","ApplicationQuery--Buttons":"ApplicationQuery_ApplicationQuery--Buttons__S+HnX"};